import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createSlots as _createSlots, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d4cf39e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = {
  key: 1,
  class: "error-msg"
}

import { IOptionsSelect } from '@/types';
import { withDefaults, ref, onMounted, watch, computed } from 'vue';
import { CalendarIcon } from '../atoms';
interface IProps {
  modelValue?: any;
  options?: IOptionsSelect[];
  placeholder?: string;
  label?: string;
  width?: string;
  multiple?: boolean;
  disabled?: boolean;
  isCalendar?: boolean;
  required?: boolean;
  hasError?: boolean;
  msgError?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomSelect',
  props: {
    modelValue: null,
    options: null,
    placeholder: { default: 'Selecione' },
    label: null,
    width: { default: 'auto' },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean },
    isCalendar: { type: Boolean, default: false },
    required: { type: Boolean },
    hasError: { type: Boolean },
    msgError: null
  },
  emits: ['onChangeDropDownList', 'update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue?: any, options?: IOptionsSelect[], placeholder: string, label?: string, width: string, multiple: boolean, disabled?: boolean, isCalendar: boolean, required?: boolean, hasError?: boolean, msgError?: string };




function handleChangeDropdownList() {
  emit('onChangeDropDownList', selectedItem.value);
}

const selectedItem = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

watch(
  () => props.options,
  () => {
    if (!selectedItem.value) selectedItem.value = props.options?.find((x) => x.selected === true)?.value;
    emit('onChangeDropDownList', selectedItem.value);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ width: props.width }),
    class: "mt-5"
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_v_autocomplete, {
      "item-title": "text",
      modelValue: _unref(selectedItem),
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedItem) ? (selectedItem).value = $event : null)),
        handleChangeDropdownList
      ],
      density: "compact",
      variant: "solo-inverted",
      "bg-color": "#F8F9FA",
      color: "primary",
      class: "border rounded",
      placeholder: props.placeholder,
      items: props.options,
      multiple: __props.multiple,
      required: __props.required,
      chips: __props.multiple,
      disabled: props.disabled,
      "item-value": "value",
      "no-data-text": 'Não há dados',
      clearable: true
    }, _createSlots({ _: 2 }, [
      (props.isCalendar)
        ? {
            name: "selection",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(CalendarIcon))
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "placeholder", "items", "multiple", "required", "chips", "disabled"]),
    (__props.hasError && __props.msgError)
      ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(__props.msgError), 1))
      : _createCommentVNode("", true)
  ], 4))
}
}

})